"use client";

import PropTypes from "prop-types";
import { Card } from "@components";
import { Box, Grow, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const ConnectCard = ({
  Icon,
  title,
  profile,
  link = "",
  inView,
  enterDelay,
}) => {
  return (
    <Grow
      in={inView}
      {...(inView ? { timeout: enterDelay * 500 } : {})}
      style={{ transformOrigin: "center 0 0" }}
    >
      <Box>
        <Card link={link}>
          <Box
            sx={{
              padding: 2,
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              textShadow: "2px 2px 5px black",
              minWidth: 140,
            }}
          >
            <Icon
              sx={(theme) => ({
                width: 75,
                height: 75,
                marginBottom: theme.spacing(1),
              })}
              alt={`${title} image`}
            />
            <Typography>{title}</Typography>
            <Typography
              sx={{
                fontSize: 12,
                display: "flex",
                alignItems: "center",
                lineHeight: 1,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <AccountCircleIcon
                sx={{ height: 15, width: 15, marginRight: 0.5 }}
              />
              {profile}
            </Typography>
          </Box>
        </Card>
      </Box>
    </Grow>
  );
};

ConnectCard.propTypes = {
  Icon: PropTypes.instanceOf(Object),
  title: PropTypes.string,
  link: PropTypes.string,
  inView: PropTypes.bool,
  enterDelay: PropTypes.number,
  profile: PropTypes.string,
};

export default ConnectCard;
